import React from 'react';
import { Grid, Typography } from '@mui/material';
import './components.css';

const ListItemButtonStack = (props) => {
  const handleAnswerChange = (value) => {
    props.onChange(props.questionKey, value);
  };

  return (
    <Grid container spacing={2} justifyContent="flex-start" alignItems="center">
      {props.options.map((option) => (
        <Grid item xs={6} sm={6} md={6} lg={6} key={option.value}>
          <div
            onClick={() => handleAnswerChange(option.value)}
            className="list-item-button"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              border: props.value === option.value ? '2px solid #00634a' : '2px solid #e0e0e0',
              borderRadius: '12px',
              backgroundColor: props.value === option.value ? '#f0f7f4' : '#ffffff',
              color: props.value === option.value ? '#00634a' : '#333',
              padding: '16px',
              minHeight: '90px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
              cursor: 'pointer',
              transition: 'all 0.3s ease-in-out',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.border = '2px solid #00634a')}
            onMouseLeave={(e) => {
              e.currentTarget.style.border =
                props.value === option.value ? '2px solid #00634a' : '2px solid #e0e0e0';
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                fontFamily: 'Poppins, sans-serif',
                fontSize: { xs: '14px', sm: '15px', md: '16px' },
                lineHeight: '1.4',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%'
              }}
            >
              {option.text}
            </Typography>
          </div>
        </Grid>
      ))}
    </Grid>
  );
};

export default ListItemButtonStack;